import { render, staticRenderFns } from "./WootKeyShortcutModal.vue?vue&type=template&id=2a6b4f42&scoped=true&"
import script from "./WootKeyShortcutModal.vue?vue&type=script&lang=js&"
export * from "./WootKeyShortcutModal.vue?vue&type=script&lang=js&"
import style0 from "./WootKeyShortcutModal.vue?vue&type=style&index=0&id=2a6b4f42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6b4f42",
  null
  
)

export default component.exports